<div class="flex flex-row gap-3" [formGroup]="settingsForm">
  <div *ngFor="let field of fields">
    <label class="block font-bold mb-2" [for]="field.id"
      >{{field.name}}</label
    >
    <input
      [inputId]="field.id"
      type="password"
      pInputText
      class="w-full p-inputtext"
      [formControlName]="field.id"
    />
  </div>
</div>
